<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />">
</ngx-spinner>

<div class="sfdc-configuration-content">
    <div class="content-top-box">
        <app-bread-crumb></app-bread-crumb>
    </div>
    <div class="header-title">
        <h1 class="main-title">{{langObj ? langObj?.ManagerExecution : ('ManagerExecution' | translate)}}</h1>
    </div>
</div>

<div class="w-100 manaForm" style="display: flow-root;">
    <mat-form-field class="w-22">
        <mat-label>{{langObj ? langObj?.LineArea : ('LineArea' | translate)}}</mat-label>
        <input required matInput [(ngModel)]="operator.LineId" readonly>
    </mat-form-field>
    <mat-form-field class="w-22">
        <mat-label>{{langObj ? langObj?.WOTimeStamp : ('WOTimeStamp' | translate)}}</mat-label>
        <input required matInput [(ngModel)]="operator.TimeStamp" readonly>
    </mat-form-field>
    <mat-form-field class="w-22">
        <mat-label>{{langObj ? langObj?.WOId : ('WOId' | translate)}}</mat-label>
        <input required matInput [(ngModel)]="operator.WOIdDisplay" readonly>
    </mat-form-field>
    <mat-form-field class="w-22">
        <mat-label>{{langObj ? langObj?.WOStatus : ('WOStatus' | translate)}}</mat-label>
        <input required matInput
            [ngClass]="{'text-green' : (operator.WOStatus == 'Complete' || operator.WOStatus == 'Close'), 'text-red' : (operator.WOStatus == 'Open' || operator.WOStatus == 'Delay'), 'text-orange' : (operator.WOStatus == 'In Progress')}"
            [(ngModel)]="operator.WOStatus" readonly>
    </mat-form-field>
    <mat-form-field class="w-22">
        <mat-label>{{langObj ? langObj?.ClosedAt : ('ClosedAt' | translate)}}</mat-label>
        <input matInput type="text" [(ngModel)]="operator.ClosedAt" formControlName="ClosedAt" readonly>
    </mat-form-field>
    <mat-form-field class="w-22">
        <mat-label>WO Type</mat-label>
        <mat-select required [(ngModel)]="operator.WOType" (selectionChange)="getWOTypeFailureData()"
            [disabled]="techResponded" [disabled]="isviewMode">
            <mat-option *ngFor="let type of woType" [value]="type.ID">
                {{type.Name}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field class="w-22">
        <mat-label>{{langObj ? langObj?.FailureMode : ('FailureMode' | translate)}}</mat-label>
        <mat-select required [(ngModel)]="operator.FailureMode" [disabled]="techResponded" [disabled]="isviewMode">
            <mat-option *ngFor="let mode of failMode" [value]="mode.ID"> {{mode.Name}} </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field class="w-22">
        <mat-label>{{langObj ? langObj?.RequestedBy : ('RequestedBy' | translate)}}</mat-label>
        <input required matInput [value]="operator.RequestedUserName" [disabled]="isviewMode" readonly>
    </mat-form-field>
    <div class="toggle-container">
        <div class="toggle">
            <label>{{langObj ? langObj?.SpareParts : ('SpareParts' | translate)}}</label>
            <mat-slide-toggle [(ngModel)]="operator.SpareParts" (change)="SpareToggle($event)"
                [disabled]="isviewMode"></mat-slide-toggle>
            <!-- <mat-slide-toggle [(ngModel)]="operator.SpareParts" (change)="SpareToggle($event)" [disabled]="isviewMode || !isviewMode"></mat-slide-toggle> -->
        </div>
        <div class="toggle">
            <label>{{langObj ? langObj?.MachineBreakdown : ('MachineBreakdown' | translate)}}</label>
            <mat-slide-toggle [(ngModel)]="operator.MachineBreakdown" [disabled]="isviewMode"></mat-slide-toggle>
        </div>
    </div>
</div>
<form [formGroup]="form">
    <div class="w-100 manaForm">
        <mat-form-field class="w-22">
            <mat-label *ngIf="!isSparePartCodeRequired">
                {{ langObj ? langObj?.SparePartCode : ('SparePartCode' | translate) }}
            </mat-label>
            <mat-label *ngIf="isSparePartCodeRequired">
                {{ langObj ? langObj?.SparePartCode : ('SparePartCode' | translate) }} *
            </mat-label>
            <input matInput [(ngModel)]="manager.SparePartCode" formControlName="SparePartCode" [readonly]="isviewMode">
            <mat-error>{{langObj ? langObj?.SparePartCodeisrequired : ('SparePartCodeisrequired' |
                translate)}}</mat-error>
        </mat-form-field>
        <mat-form-field class="w-22">
            <mat-label>{{langObj ? langObj?.Priority : ('Priority' | translate)}}</mat-label>
            <mat-select required [(ngModel)]="manager.Priority" formControlName="Priority" [disabled]="techResponded"
                [disabled]="isviewMode">
                <mat-option *ngFor="let Priority of PriorityList" [value]="Priority.ID">
                    {{Priority.Name}}
                </mat-option>
            </mat-select>
            <mat-error>{{langObj ? langObj?.Priorityisrequired : ('Priorityisrequired' | translate)}}</mat-error>
        </mat-form-field>
        <mat-form-field appearence="fill" class="date-time" class="w-22">
            <mat-label>{{"Assign Technician Time"}}</mat-label>
            <!-- <input 
                matInput
                readonly
                [ngxMatDatetimePicker]="picker"
                formControlName="AssignTechnicianTimeStamp"
                [(ngModel)]="manager.AssignTechnicianTimeStamp"
                [disabled]="isviewMode"  [disabled]="techResponded" (dateChange)="validateAssignTechnicianTimeStamp()"
                required
            > -->
            <input matInput [ngxMatDatetimePicker]="picker" formControlName="AssignTechnicianTimeStamp"
                [(ngModel)]="manager.AssignTechnicianTimeStamp" (dateChange)="validateAssignTechnicianTimeStamp()"
                [readonly]="isviewMode || techResponded" [disabled]="isviewMode || techResponded" required [max]="maxSelectableDateTime$ | async">
            <mat-datepicker-toggle matSuffix [for]="$any(picker)"> </mat-datepicker-toggle>
            <ngx-mat-datetime-picker #picker [enableMeridian]="true" [max]="maxSelectableDateTime$ | async"> </ngx-mat-datetime-picker>
            <mat-error>{{langObj ? langObj?.AssignTechnicianTimeisrequired : ('AssignTechnicianTimeisrequired' |
                translate)}}</mat-error>
        </mat-form-field>

        <mat-form-field class="w-22">
            <mat-label>{{langObj ? langObj?.AssignTechnician : ('AssignTechnician' | translate)}}</mat-label>
            <mat-select #select1 [multiple]="true" required formControlName="assignUser"
                (openedChange)="comboChange($event, 'filter1')" [disabled]="techResponded || isviewMode">
                <mat-select-filter id="filter1" [placeholder]="'Search'" [displayMember]="'fullName'"
                    [array]="newUserFiltList" (filteredReturn)="userFiltList = $event">
                </mat-select-filter>
                <mat-option (click)="selectAllItems()" value="0">All</mat-option>
                <mat-option *ngFor="let user of userFiltList" [value]="user.employeeCode">
                    {{user.fullName}} <span>( {{woTypeName}} - {{user.uniqueScores ? user.uniqueScores : '0'}} , Avg -
                        {{user.avgScores ? user.avgScores : '0'}} )</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
        <div class="row">

            <mat-form-field class="remarks">
                <mat-label>{{langObj ? langObj?.ManagerRemarks : ('ManagerRemarks' | translate)}}</mat-label>
                <textarea required matInput [(ngModel)]="manager.ManagerRemarks" formControlName="ManagerRemarks"
                    [readonly]="isviewMode" maxlength="1000"></textarea>
                <div class="hint-wrapper">
                    <span class="max-char-hint">Max 1000 characters</span>
                    <mat-hint align="end" style="margin-left: 25px;">{{ form.value?.ManagerRemarks?.length || 0
                        }}/1000</mat-hint>
                </div>
                <mat-error>{{langObj ? langObj?.ManagerRemarksisrequired : ('ManagerRemarksisrequired' |
                    translate)}}</mat-error>
            </mat-form-field>

            <mat-form-field appearence="fill" class="remarks">
                <mat-label>{{langObj ? langObj?.WorkOrderDetails : ('WorkOrderDetails' | translate)}}</mat-label>
                <textarea required matInput [(ngModel)]="operator.Remark" formControlName="remark"
                    [readonly]="isviewMode" maxlength="1000"></textarea>
                <div class="hint-wrapper">
                    <span class="max-char-hint">Max 1000 characters</span>
                    <mat-hint align="end" style="margin-left: 25px;">{{ form.value?.remark?.length || 0
                        }}/1000</mat-hint>
                </div>
                <mat-error>{{langObj ? langObj?.WorkOrderDetailsisrequired : ('WorkOrderDetailsisrequired' |
                    translate)}}</mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="dummy w-22">
        <input type="hidden" name="">
    </div>

    <h2 *ngIf="OperatorFiles && OperatorFiles.length">{{langObj ? langObj?.OperatorImages : ('OperatorImages' |
        translate)}}</h2>
    <div *ngIf="OperatorFiles && OperatorFiles.length" class="imgflex">
        <div *ngFor="let file of OperatorFiles; let i = index" class="relative">
            <div>
                <img [src]="blobStorageUrl+file.ImageSrc" alt="" width="250px" height="200px" (click)="imgview($event)">
            </div>
        </div>
    </div>

    <h4 *ngIf="TechnicianFiles && TechnicianFiles.length">{{langObj ? langObj?.TechnicianImages : ('TechnicianImages' |
        translate)}}</h4>
    <div *ngIf="TechnicianFiles && TechnicianFiles.length" class="imgflex m-0">
        <div *ngFor="let file of TechnicianFiles; let i = index" class="relative">
            <div>
                <img [src]="blobStorageUrl+file.ImageSrc" alt="" width="250px" height="200px"
                    (click)="imgview1($event)">
            </div>
        </div>
    </div>
    <div class="action">
        <button class="cancel" routerLink="/PM/ManagerExecutionWindow" type="button">{{langObj ? langObj?.Cancel :
            ('Cancel' | translate)}}</button>
        <button class="submit" type="submit" (click)="onSubmit()"
            *ngIf="!isviewMode && (isUpdate | permissionChecker)">{{langObj ?
            langObj?.Submit : ('Submit' | translate)}}</button>
    </div>

    <div class="w-100 prevForm">
        <mat-tab-group>

            <mat-tab>
                <ng-template mat-tab-label>
                    {{langObj ? langObj?.ExternalWork : ('ExternalWork' | translate)}}
                </ng-template>
                <button style="margin-top: 10px;" mat-flat-button color="accent" (click)="openWOdialog()"
                    [disabled]="operator.WOStatus === 'Complete' || isEdit === false ">
                    <!-- {{langObj ? langObj?.AddExternalWork : ('AddExternalWork' | translate)}} -->
                    {{langObj ? langObj?.AddWorkOrder : ('AddWorkOrder' | translate)}}

                </button>
                <ag-grid-angular style="width: 100%; height: 24vw; margin-top: 10px;" class="ag-theme-alpine"
                    [rowData]="rowData" [columnDefs]="columnDefs" (gridReady)="onGridReady($event)"
                    (cellClicked)="cellClicked($event)" [gridOptions]="gridOptions"
                    [frameworkComponents]="frameworkComponents" [pagination]="true" [paginationPageSize]="10">
                </ag-grid-angular>
            </mat-tab>

            <!-- <mat-tab label="External Work">
                <app-prev-task-external-work></app-prev-task-external-work>
            </mat-tab> -->

        </mat-tab-group>
    </div>
</form>

<!-- img popup -->
<ng-template #manageroperatorimageViewModal>
    <button mat-mini-fab color="warn" (click)="oncloseimg()"><mat-icon>close</mat-icon></button>
    <mat-carousel timings="250ms ease-in" [autoplay]="false" interval="5000" color="accent" [loop]="true"
        [hideArrows]="false" [hideIndicators]="false" [useKeyboard]="true" [useMouseWheel]="true" orientation="ltr">
        <mat-carousel-slide #matCarouselSlide *ngFor="let file of OperatorFiles; let i = index"
            [image]="blobStorageUrl+file.ImageSrc" overlayColor="#00000040" [hideOverlay]="false"></mat-carousel-slide>
    </mat-carousel>
</ng-template>
<ng-template #managertechnicianimageViewModal>
    <button mat-mini-fab color="warn" (click)="oncloseimg1()"><mat-icon>close</mat-icon></button>
    <mat-carousel timings="250ms ease-in" [autoplay]="false" interval="5000" color="accent" [loop]="true"
        [hideArrows]="false" [hideIndicators]="false" [useKeyboard]="true" [useMouseWheel]="true" orientation="ltr">
        <mat-carousel-slide #matCarouselSlide *ngFor="let file of TechnicianFiles ; let i = index"
            [image]="blobStorageUrl+file.ImageSrc" overlayColor="#00000040" [hideOverlay]="false"></mat-carousel-slide>
    </mat-carousel>
</ng-template>
<!-- end img popup -->

<ng-template #subTaskDialog>
    <div mat-dialog-title class="mat-title">
        <div class="d-flex justify-content-between align-items-center">
            <h1 class="main-title" *ngIf="subtaskFormMode">Add Sub Work Order</h1>
            <h1 class="main-title" *ngIf="!subtaskFormMode && !isViewMode">Update Sub Work Order</h1>
            <h1 class="main-title" *ngIf="isViewMode">View Sub Work Order</h1>
            <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
                <i class="fa fa-times" style="color: #fff"></i>
            </button>
        </div>
    </div>

    <!-- Form -->
    <form [formGroup]="subTaskForm" (ngSubmit)="subtaskFormMode ? submitForm() : updateSubtaskForm()">
        <div class="w-100 prevForm">
            <input type="hidden" formControlName="Id">
            <!-- WO Details -->
            <mat-form-field appearence="fill" class="remarks" style="margin-top:10px;">
                <mat-label>{{langObj ? langObj?.SubWODetail : ('SubWODetail' | translate)}} *:</mat-label>
                <textarea matInput rows="3" type="text" formControlName="woDetails"
                    placeholder="Enter Sub Work Order details"> </textarea>
            </mat-form-field>
            <!-- Target Date -->
            <mat-form-field class="w-22">
                <mat-label>{{langObj ? langObj?.targetDate : ('Target Date' | translate)}} *:</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="targetDate"
                    [matDatepickerFilter]="disablePastDates" placeholder="Choose a date" />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <!-- Responsible (Dropdown of Technician Names) -->
            <mat-form-field class="w-22">
                <mat-label>{{langObj ? langObj?.responsible : ('Responsible' | translate)}} *:</mat-label>
                <mat-select formControlName="responsible"
                    (openedChange)="onPanelClose($event,'tech', machineSearchInput)">
                    <input #machineSearchInput (keyup)="searchValues($event,'tech')" class="form-control w-100"
                        placeholder="Search Technicians">
                    <mat-option *ngFor="let tech of filteredTechnicianList" [value]="tech.id">
                        {{ tech.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Vendor Section: Toggle and Dropdown/Input in one row (inline with Responsible) -->
            <div style="display: inline-flex; align-items: center; width: 31.5%; gap: 10px; vertical-align: top;">
                <!-- Toggle to Choose Vendor Input Type -->
                <mat-slide-toggle #vendorElement [checked]="vendorToggle" (change)="onVendorToggleChange($event)"
                    style="white-space: nowrap; margin-top: 10px;">
                    <mat-label>{{langObj ? langObj?.addVendor : ('Add New Vendor' | translate)}}</mat-label>
                </mat-slide-toggle>

                <!-- External Vendor Dropdown -->
                <mat-form-field *ngIf="vendorMode === 'existing'" style="flex: 1;">
                    <mat-label>{{langObj ? langObj?.externalVendor : ('Select External Vendor' |
                        translate)}}</mat-label>
                    <mat-select formControlName="externalVendor"
                        (openedChange)="onPanelClose($event,'vender', venderSearchInput)">
                        <input #venderSearchInput (keyup)="searchValues($event,'vender')" class="form-control w-100"
                            placeholder="Search Vendor">
                        <mat-option *ngFor="let vendor of vendorsList" [value]="vendor.Id">
                            {{ vendor.Name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <!-- New Vendor Input -->
                <mat-form-field *ngIf="vendorMode === 'new'" style="flex: 1;">
                    <mat-label>{{langObj ? langObj?.newVendor : ('Enter New Vendor' | translate)}}</mat-label>
                    <input matInput placeholder="Enter vendor name" formControlName="newVendorName" />
                </mat-form-field>
                <!-- Remarks -->

            </div>
            <!-- <mat-form-field class="remarks" style="margin-top:10px;">
                <mat-label>{{langObj ? langObj?.remarks : ('Remarks' | translate)}}</mat-label>
                <textarea matInput rows="3" formControlName="remarks" placeholder="Enter remarks"
                    [readonly]="!subtaskFormMode"></textarea>
            </mat-form-field> -->

            <!-- Buttons -->
            <div class="form-buttons mt-3" style="display: flex; justify-content: flex-end;" *ngIf="!isViewMode">
                <button mat-flat-button color="accent" style="margin-top: .5rem;" *ngIf="subtaskFormMode"
                    [disabled]="!subTaskForm.valid" type="submit">Submit</button>
                <button mat-flat-button color="accent" style="margin-top: .5rem;" *ngIf="!subtaskFormMode"
                    [disabled]="!subTaskForm.valid" type="submit">Update</button>
            </div>
        </div>
    </form>
</ng-template>